//#region src/components/ui/tooltip/injectionKeys.ts
var e = Symbol("TOOLTIP_OPEN_MODEL_VALUE_KEY");
//#endregion
export { e as TOOLTIP_OPEN_MODEL_VALUE_KEY };

//# sourceMappingURL=injectionKeys.js.map